import React, { Suspense } from 'react';
import { defer, useLoaderData, Await } from "react-router-dom";
import LoadingScreen from './LoadingScreen';
import {createPercentFormatter, createDollarFormatter, createNumberFormatter, createLinkFormatter} from './TableUtils.js';
import './TableUtils.css';

import 'react-tabulator/lib/styles.css';
import 'react-tabulator/lib/css/tabulator.min.css';
import { ReactTabulator } from 'react-tabulator'

let _accountsCache = null;
const getAccounts = async () => {
  if (_accountsCache) return _accountsCache;
  const url = (process.env.NODE_ENV === 'development' ? '/current_account_asset_values_usd.json' : '/current_account_asset_values_usd');
  _accountsCache = await fetch(url).then((res) => res.json());
  return _accountsCache;
}

export const loader = async ({ params }) => {
  if (_accountsCache) return {accounts: _accountsCache};
  const accounts = getAccounts();
  return defer({accounts});
}

function Accounts() {
  const loaderData = useLoaderData();

  return (
    <Suspense fallback={<LoadingScreen visible="true" />}>
      <Await resolve={loaderData.accounts}
             errorElement={<div>Error Loading</div>}>
        {(accounts) => (
          <div className="accounts">
            <ReactTabulator
              options={{
                data: accounts,
                dataTree:true,
                dataTreeStartExpanded: [true, true, false],
                responsiveLayout: "hide",
              }}
             columns={[
                { title: "Account", field: "account", responsive: 0, minWidth: 130,
                  formatter: createLinkFormatter((cell) => `/transactions?account=${cell.getValue()}`),
                },
                { title: 'Symb.', field: 'symbol', responsive: 0, minWidth: 35,
                  formatter: createLinkFormatter((cell) => {
                    const account = cell.getData().account;
                    const symbol = cell.getValue();
                    return `/transactions?account=${account}&symbol=${symbol}`;
                  }),
                },
                { title: '#', field: 'quantity', responsive: 5, formatter: createNumberFormatter(2), hozAlign:'right', minWidth: 100, },
                { title: '$', field: 'asset_value_usd', responsive: 0, formatter: createDollarFormatter(0), hozAlign:'right', minWidth: 95, },
                { title: 'wΔ', field: 'd7_change', responsive: 2, formatter: createPercentFormatter(1), hozAlign:'right', minWidth: 55, },
                { title: 'mΔ', field: 'd30_change', responsive: 3, formatter: createPercentFormatter(1), hozAlign:'right', minWidth: 55, },
                { title: 'yΔ', field: 'd365_change', responsive: 4, formatter: createPercentFormatter(1), hozAlign:'right', minWidth: 55, },
                { title: ' ', field: '', responsive: 6, minWidth: 30, headerSort: false,
                  formatter: (cell) => {
                    const row = cell.getData();
                    if (!row.symbol) return '';
                    var link = document.createElement("a");
                    link.href = `#/balance?account=${encodeURIComponent(row.account)}&symbol=${encodeURIComponent(row.symbol)}`;
                    link.title = "Historical balances";
                    link.textContent = "\u{1F4C8}";
                    link.style.textDecoration = "none";
                    return link;
                  },
                },
              ]}
            />
          </div>
        )}
      </Await>
    </Suspense>
  );
}

export default Accounts;
